function getEnv(key) {
  if (typeof window !== 'undefined' && window._env_ && window._env_[key]) {
    return window._env_[key];
  }
  return process.env[key];
}

const PLACETOPAY_TOKENIZE_URL = getEnv('REACT_APP_PLACETOPAY_TOKENIZE_URL');

export default async function createPlaceToPayTokenize(body) {
  if (!PLACETOPAY_TOKENIZE_URL) throw new Error('REACT_APP_PLACETOPAY_TOKENIZE_URL is not set.');

  const response = await fetch(PLACETOPAY_TOKENIZE_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(body),
  });

  if (!response.ok) throw new Error(`Tokenize HTTP ${response.status}`);
  return response.json();
}